<div *ngFor="let dimension of options" class="ui form">
  <div *ngIf="dimension.properties.length" class="field">
    <label>{{ dimension.displayName }}</label>
    <div class="inline fields">
      <div *ngFor="let property of dimension.properties" class="field">
        <div class="ui checkbox filter-container">
          <input
            id="{{ dimension.name }}{{ property.name }}"
            type="checkbox"
            [ngModel]="isSelected(dimension, property)"
            (ngModelChange)="toggleItem($event, dimension, property)"
          />
          <label for="{{ dimension.name }}{{ property.name }}">{{ property.displayName }}</label>
          <a
            *ngIf="propertySelectionStates[dimension.name + '.' + property.name] && canOrderResult && property.isSortable"
            (click)="onOrderBy($event, dimension, property)"
            class="filter"
            [class.active]="orderState[dimension.name + '.' + property.name]"
          >
            <ng-container [ngSwitch]="orderState[dimension.name + '.' + property.name]">
              <i *ngSwitchCase="-1" class="sort amount down icon"></i>
              <i *ngSwitchCase="1" class="vertically flipped sort amount down icon"></i>
              <i *ngSwitchDefault class="sort amount down icon"></i>
            </ng-container>
          </a>
        </div>
        <span
          *ngIf="property.meta?.display?.description"
          (click)="showDescription(property)"
          class="info-icon"
        >
          <i class="fa-solid fa-circle-info"></i>
        </span>
      </div>
    </div>
  </div>
</div>

<p-dialog
  [header]="property?.name"
  [(visible)]="descriptionVisible"
  dismissableMask="true"
  modal="true"
>
  <p>
    {{ property?.description }}
  </p>
</p-dialog>
